const REPORTE_MANUAL_FROM_LINK_STORAGE_KEY = 'hdv-tour-reporte-manual-from-link'
const HELP_REPORTE_MANUAL_SELECTOR = '[data-tour="help-reporte-manual"]'
const START_REPORTE_MANUAL_LINK_SELECTOR = '.driver-popover-description [data-hdv-start-tour="reporte-manual"]'

const isLancamentoPage = () => /\/virtual\/[^/]+\/lancamento/.test(window.location.pathname)
const hasEquipamentosVirtuaisNaTabela = () => document.querySelectorAll('[data-tour="reporte-manual-tabela"] tbody tr').length > 0

const bindMinimizeTourOnClick = (element, tourManager) => {
    if (!element || element._hdvTourMinimizeClick) return

    const minimizeTourOnClick = () => tourManager.minimize()

    element.addEventListener('click', minimizeTourOnClick)
    element._hdvTourMinimizeClick = minimizeTourOnClick
}

const unbindMinimizeTourOnClick = (element) => {
    if (!element?._hdvTourMinimizeClick) return

    element.removeEventListener('click', element._hdvTourMinimizeClick)
    delete element._hdvTourMinimizeClick
}

const markReporteManualFromLink = () => {
    try {
        sessionStorage.setItem(REPORTE_MANUAL_FROM_LINK_STORAGE_KEY, '1')
    } catch (_error) {}
}

const consumeReporteManualFromLink = () => {
    try {
        const fromLinkFlag = sessionStorage.getItem(REPORTE_MANUAL_FROM_LINK_STORAGE_KEY)

        if (fromLinkFlag) {
            sessionStorage.removeItem(REPORTE_MANUAL_FROM_LINK_STORAGE_KEY)
            return true
        }
    } catch (_error) {}

    return false
}

export const bindReporteManualTourLink = (tourManager, fromTourName) => {
    setTimeout(() => {
        const startTourLink = document.querySelector(START_REPORTE_MANUAL_LINK_SELECTOR)

        if (!startTourLink || startTourLink._hdvTourStartBound) return

        startTourLink._hdvTourStartBound = true
        startTourLink.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            markReporteManualFromLink()
            tourManager.handoff(fromTourName, 'reporte-manual', HELP_REPORTE_MANUAL_SELECTOR)
        })
    }, 0)
}

const buildFormSteps = (tourManager) => [
    {
        popover: {
            title: 'Reporte Manual',
            description: 'Aqui você simula o envio de um pacote do equipamento virtual. Os valores preenchidos alimentam os parâmetros e, depois, os gráficos do monitorado.',
        },
    },
    {
        element: '[data-tour="reporte-manual-parametro"]',
        popover: {
            title: 'Parâmetro',
            description: 'Escolha o parâmetro que deseja reportar. O tipo (inteiro, decimal, texto ou verdadeiro/falso) aparece ao lado.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="reporte-manual-valor"]',
        popover: {
            title: 'Valor',
            description: 'Informe o valor que o equipamento “enviaria” nesse pacote.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="reporte-manual-data-hora"]',
        popover: {
            title: 'Data e hora',
            description: 'Defina quando a leitura ocorreu. Isso posiciona o ponto no histórico e nos gráficos.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="reporte-manual-preview"]',
        popover: {
            title: 'Prévia do pacote',
            description: 'À direita você vê o pacote montado com os valores atuais. Use como conferência antes de enviar.',
            side: 'left',
            align: 'start',
        },
    },
    {
        element: '[data-tour="reporte-manual-reportar"]',
        popover: {
            title: 'Reportar',
            description: 'Clique em <strong>Reportar</strong> para enviar o pacote. Em seguida, os parâmetros e os gráficos do monitorado passam a refletir esses dados.',
            side: 'top',
            align: 'start',
        },
        onHighlighted: (element) => bindMinimizeTourOnClick(element, tourManager),
        onDeselected: (element) => unbindMinimizeTourOnClick(element),
    },
    {
        popover: {
            title: 'Pronto!',
            description: 'Repita o reporte sempre que quiser alimentar novos valores. Sem pacotes manuais, o equipamento virtual não gera leituras sozinho.',
        },
    },
]

const buildGridSteps = (tourManager, { veioDoLinkDeOutroTour = false } = {}) => {
    const steps = []

    if (!veioDoLinkDeOutroTour) {
        steps.push({
            popover: {
                title: 'Reporte Manual',
                description: 'É necessário ter um <strong>equipamento virtual</strong> cadastrado para usar esta tela.<br><br>O Reporte Manual funciona como um simulador de pacotes: você envia dados “à mão”, como se o equipamento tivesse comunicado, para alimentar parâmetros e gráficos do monitorado.',
            },
        })
    } else {
        steps.push({
            popover: {
                title: 'Reporte Manual',
                description: 'Aqui o equipamento virtual envia pacotes manualmente. É o caminho para alimentar parâmetros e, em seguida, os gráficos do monitorado.',
            },
        })
    }

    steps.push({
        element: '[data-tour="reporte-manual-tabela"]',
        popover: {
            title: 'Equipamentos virtuais',
            description: hasEquipamentosVirtuaisNaTabela()
                ? 'A lista mostra os equipamentos virtuais disponíveis. Selecione um deles na tabela para liberar o reporte.'
                : 'Quando existir um equipamento virtual cadastrado, ele aparece nesta lista. Cadastre um em Equipamentos (modelo virtual) antes de reportar.',
            side: 'top',
            align: 'start',
        },
    })

    steps.push({
        element: '[data-tour="reporte-manual-realizar"]',
        popover: {
            title: 'Realizar Reporte',
            description: 'Com um equipamento selecionado, clique em <strong>Realizar Reporte</strong> para abrir o formulário e montar o pacote.',
            side: 'bottom',
            align: 'start',
        },
        onHighlighted: (element) => bindMinimizeTourOnClick(element, tourManager),
        onDeselected: (element) => unbindMinimizeTourOnClick(element),
    })

    steps.push({
        popover: {
            title: 'Pronto!',
            description: 'No formulário, escolha o parâmetro, o valor e a data/hora, confira a prévia e clique em <strong>Reportar</strong>. Se quiser, abra a ajuda nessa tela para um guia passo a passo do formulário.',
        },
    })

    return steps
}

const buildReporteManualTourSteps = (tourManager) => {
    if (isLancamentoPage()) {
        return buildFormSteps(tourManager)
    }

    return buildGridSteps(tourManager, {
        veioDoLinkDeOutroTour: consumeReporteManualFromLink(),
    })
}

export default buildReporteManualTourSteps
